import { render } from "./FinCoinLeaderboard.vue?vue&type=template&id=058b2501&scoped=true"
import script from "./FinCoinLeaderboard.vue?vue&type=script&lang=js"
export * from "./FinCoinLeaderboard.vue?vue&type=script&lang=js"

import "./FinCoinLeaderboard.vue?vue&type=style&index=0&id=058b2501&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-058b2501"]])

export default __exports__